/* Pertegaz wishlist — client-side (localStorage) saving + side drawer.
   Works for guests; every bookmark icon on the page stays in sync, and the header shows a count. */
(function () {
  if (window.__pzWishlistInit) return;
  window.__pzWishlistInit = true;

  var KEY = 'pz_wishlist_v1';

  // ---- store ----
  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function itemFrom(btn) {
    return {
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title') || '',
      url: btn.getAttribute('data-url') || '#',
      image: btn.getAttribute('data-image') || '',
      price: btn.getAttribute('data-price') || '',
      compare: btn.getAttribute('data-compare') || ''
    };
  }
  function toggle(item) {
    var list = read();
    var i = list.findIndex(function (x) { return x.handle === item.handle; });
    if (i >= 0) list.splice(i, 1);
    else list.unshift(item);       // newest first
    write(list);
    syncAll();
    return i < 0;                  // true if now saved
  }
  function remove(handle) {
    write(read().filter(function (x) { return x.handle !== handle; }));
    syncAll();
  }

  // ---- sync every icon + counts + drawer ----
  function syncIcons() {
    document.querySelectorAll('[data-pz-wish]').forEach(function (btn) {
      var h = btn.getAttribute('data-handle');
      btn.setAttribute('aria-pressed', h && has(h) ? 'true' : 'false');
    });
  }
  function syncCounts() {
    var n = read().length;
    document.querySelectorAll('[data-pz-wish-count]').forEach(function (el) {
      el.textContent = String(n);
      el.hidden = n === 0;
      el.setAttribute('aria-hidden', n === 0 ? 'true' : 'false');
    });
  }
  function syncDrawer() {
    var listEl = document.querySelector('[data-pz-wish-list]');
    var emptyEl = document.querySelector('[data-pz-wish-empty]');
    if (!listEl) return;
    var list = read();
    if (emptyEl) emptyEl.hidden = list.length > 0;
    // markup mirrors the cart drawer item (.pz-cart-item), minus the quantity stepper
    listEl.innerHTML = list.map(function (i) {
      var img = i.image ? '<img src="' + escAttr(i.image) + '" alt="" loading="lazy">' : '';
      var price = (i.compare && i.compare !== i.price)
        ? '<s class="pz-wish-item__price-old">' + escHtml(i.compare) + '</s><span>' + escHtml(i.price) + '</span>'
        : escHtml(i.price);
      return '<li class="pz-wish-item" data-handle="' + escAttr(i.handle) + '">' +
        '<a class="pz-wish-item__media" href="' + escAttr(i.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="pz-wish-item__info">' +
          '<div class="pz-wish-item__head">' +
            '<a class="pz-wish-item__name" href="' + escAttr(i.url) + '">' + escHtml(i.title) + '</a>' +
            '<span class="pz-wish-item__price">' + price + '</span>' +
          '</div>' +
          '<div class="pz-wish-item__bottom">' +
            '<div class="pz-wish-item__actions">' +
              '<button type="button" class="pz-wish-action" data-pz-wish-remove="' + escAttr(i.handle) + '">Eliminar</button>' +
              '<button type="button" class="pz-wish-action" data-pz-wish-tocart="' + escAttr(i.handle) + '" data-url="' + escAttr(i.url) + '">Mover a la cesta</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('');
  }
  function syncAll() { syncIcons(); syncCounts(); syncDrawer(); }

  function add(item) {
    if (!item || !item.handle) return;
    var list = read();
    if (!list.some(function (x) { return x.handle === item.handle; })) {
      list.unshift(item);
      write(list);
      syncAll();
    }
  }
  // shared API — used by the cart "Guardar" button (pz-cart.js) so everything writes one store
  window.pzWishlist = { add: add, remove: remove, has: has, toggle: toggle, all: read };

  function escHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function escAttr(s) { return escHtml(s).replace(/'/g, '&#39;'); }

  // ---- drawer open / close ----
  function drawer() { return document.querySelector('[data-pz-wish-drawer]'); }
  function relocate() {
    var d = drawer();
    if (d && d.parentNode !== document.body) document.body.appendChild(d);
  }
  function openDrawer() {
    relocate();
    var d = drawer(); if (!d) return;
    syncDrawer();
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.body.classList.add('overflow-hidden');
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () { d.hidden = true; }, 340);
  }

  // ---- events (delegated) ----
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-pz-wish]');
    if (toggleBtn) {
      e.preventDefault(); e.stopPropagation();
      var item = itemFrom(toggleBtn);
      if (item.handle) toggle(item);
      return;
    }
    if (e.target.closest('[data-pz-wish-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-pz-wish-close]')) { e.preventDefault(); closeDrawer(); return; }
    var rm = e.target.closest('[data-pz-wish-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-pz-wish-remove')); return; }
    var tc = e.target.closest('[data-pz-wish-tocart]');
    if (tc) { e.preventDefault(); moveToCart(tc.getAttribute('data-pz-wish-tocart'), tc.getAttribute('data-url'), tc); return; }
  });

  // ---- move an item to the cart ----
  function moveToCart(handle, url, btn) {
    if (!handle) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = (window.pzI18n&&window.pzI18n.adding)||'Añadiendo…';
    function fail() { btn.disabled = false; btn.textContent = orig; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variants = p.variants || [];
        // multiple variants (e.g. sizes) → let the customer choose on the product page
        if (variants.length > 1) { window.location.href = url || p.url; return; }
        var v = variants[0];
        if (!v || v.available === false) { btn.textContent = (window.pzI18n&&window.pzI18n.soldOut)||'Agotado'; return; }
        if (typeof window.pzAddToCart === 'function') {
          window.pzAddToCart(v.id, function () { remove(handle); closeDrawer(); }, fail);
        } else {
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
            .then(function () { remove(handle); window.location.href = '/cart'; })
            .catch(fail);
        }
      })
      .catch(fail);
  }

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key === 'Escape' && d && d.classList.contains('is-open')) closeDrawer();
  });

  // keep in sync across tabs
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });

  // initial paint (and re-paint after AJAX filtering / pagination adds cards)
  function init() { relocate(); syncAll(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', syncAll);
  // re-sync icons when new cards are injected (infinite scroll / facet filtering), debounced
  var moRaf = null;
  var mo = new MutationObserver(function () {
    if (moRaf) return;
    moRaf = requestAnimationFrame(function () { moRaf = null; syncIcons(); });
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
